module.exports = __webpack_public_path__ + "img/ad-style.2f6090df.png";